<script setup>
import Web from '@/components/camp/camp.vue'
import Mobile from '@/components/camp/camp-mobile.vue'
const IS_H5 = /Android|webOS|iPhone|iPad|IEMobile|Opera Mini/i.test(navigator.userAgent)
</script>
<template>
  <!-- /* 判读是从哪个入口进入 */ -->
  <Mobile v-if="IS_H5" />
  <Web v-else />
</template>
<style lang="scss" scoped></style>
